import { FC } from 'react';

import { AppRoutes } from 'constants/routes-paths.constants';
import { Complaint } from 'interfaces/complaints.interfaces';
import { ColumnDefaultControls } from 'shared-components/table/ColumnDefaultControls';
import { TableData } from 'shared-components/table/TableData';
import { TableRow } from 'shared-components/table/TableRow';
import { formatToDefaultDate, parseDefaultDate } from 'utils/date.utils';
import { getCommonRoutes } from 'utils/routes.utils';

interface Props {
  handleDelete: VoidFunction;
  data: Complaint;
}

export const ComplaintsTableRow: FC<Props> = ({
  handleDelete,
  data: { id, createdAt, description, customer, responsible },
}) => {
  const { editRoute, viewRoute } = getCommonRoutes(AppRoutes.complaints, id);

  const creationDate = parseDefaultDate(createdAt);

  return (
    <TableRow>
      <TableData>
        <ColumnDefaultControls
          handleDelete={handleDelete}
          editRoute={editRoute}
          viewRoute={viewRoute}
          editPermission='complaints.update'
          deletePermission='complaints.delete'
          viewPermission='complaints.view'
        />
      </TableData>
      <TableData>{id}</TableData>
      <TableData>{formatToDefaultDate(creationDate)}</TableData>
      <TableData>{description}</TableData>
      <TableData>{customer?.name}</TableData>
      <TableData className='last:text-left'>{responsible?.name}</TableData>
    </TableRow>
  );
};
